import styled from 'styled-components';

export const Title = styled.h1`
  color: var(--text);
  font-weight: 550;
`;

export const Project = styled.div`
  max-width: 533px;
  margin: 0 auto;
  text-align: left;
  color: var(--text);
`;

export const DensityToggle = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 1;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border-radius: 2px;
  background-color: var(--border-light);
`;

export const DensityToggleButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0.25rem;
  border: none;
  border-radius: 1px;
  background-color: ${({ $active }) =>
    $active ? 'var(--surface-elevated)' : 'transparent'};
  box-shadow: ${({ $active }) =>
    $active ? '2px 2px 0 rgba(0, 0, 0, 0.06)' : 'none'};
  opacity: ${({ $active }) => ($active ? 1 : 0.5)};
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};

  &:hover {
    opacity: 1;
  }
`;

export const DrawingActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
`;

export const DrawingBox = styled.div`
  background-color: var(--surface);
  border-radius: 2px;
  padding: 16px;
  border: 1px solid var(--border);
  box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  & a {
    text-decoration: none;
  }

  & p {
    color: var(--text-muted);
    font-size: 14px;
    margin: 4px 0 0 0;
  }

  & p span {
    display: block;
  }

  & h2 {
    font-size: 18px;
    font-weight: 550;
    line-height: 21.78px;
    text-align: left;
    margin: 0;
    color: var(--text);
  }
`;

export const Drawings = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CompactDrawings = styled(Drawings)`
  gap: 0.25rem;
`;

export const CompactDrawingBox = styled(DrawingBox)`
  padding: 6px 8px 6px 12px;
  gap: 0.5rem;
  box-shadow: none;

  & a {
    display: flex;
    align-items: baseline;
    gap: 0.75rem;
    min-width: 0;
    flex: 1;
  }

  & h2 {
    min-width: 0;
    font-size: 14px;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & p {
    display: flex;
    flex-shrink: 0;
    gap: 0.4rem;
    font-size: 12px;
    margin: 0;
    white-space: nowrap;
  }
`;

export const DrawingActionsTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 2px;
  background-color: transparent;
  font-size: 18px;
  color: var(--text-muted);
  cursor: pointer;
  user-select: none;

  &:hover,
  &[aria-expanded='true'] {
    background-color: var(--border-light);
  }
`;

export const DrawingActionsMenu = styled.div`
  display: flex;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
  flex-direction: column;
  align-items: stretch;
  background-color: var(--surface);
  border: 1px solid var(--border);
  box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 4px 0;
`;

export const CompactDrawingActions = styled.div`
  position: relative;
  flex-shrink: 0;
  outline: none;
`;

export const PromoBox = styled.div`
  background: var(--hover-blue);
  border: 1px solid rgba(4, 98, 243, 0.4);
  box-shadow: 0px 2px 0 rgba(21, 36, 55, 0.12);
  display: flex;
  justify-content: flex-start;
  padding: 1rem;
  gap: 1rem;
  align-items: center;
`;

export const NewProjectBox = styled.div`
  background-color: var(--surface);
  border-radius: -0px;
  padding: 16px;
  border: 1px solid var(--border);
  box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;

  & p {
    opacity: 0.8;
    font-size: 14px;
    margin: 4px 0 8px 0;
  }

  & h2 {
    font-size: 18px;
    font-weight: 550;
    line-height: 21.78px;
    text-align: left;
    margin: 4px 0 8px 0;
    color: var(--text);
  }
`;

export const SignOut = styled.button`
  background-color: transparent;
  border: none;
  color: var(--active-blue);
  font-size: 12px;

  &:hover {
    cursor: pointer;
  }
`;
